import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { Router } from "@angular/router";

@Injectable()
export class AuthService {
  isLoggedIn: boolean = false;
  redirect: string; // Define the 'redirect' property here
  member: any = sessionStorage.getItem("MembersData");

  
  constructor(private router: Router) {}

  login(): Observable<boolean> {
    return of(true).pipe(
      delay(1000),
      tap(val => {
        this.isLoggedIn = true;
        localStorage.setItem('isLoggedIn', 'true');
      })
    );
  }

  logout(): void {
    this.isLoggedIn = false;
    localStorage.setItem('isLoggedIn', 'false');
    sessionStorage.removeItem('CustomerId');
    sessionStorage.removeItem("MembersData");
    // Other cleanup steps...
    this.router.navigate(['/login']);
  }
}
